<form [formGroup]="resetForm">
    <app-tool-inspect-tree
        [isScanListenerActive]="isScanListenerActive"
        [isMaterial]="false"
        [labelText]="'atom.tool-returns.inspect-details.scanner.label' | translate"
        [emptyMessage]="'atom.tool-returns.inspect-details.scanner.emptyText' | translate"
        [formControl]="resetForm.controls['scannedTool']"
        [items]="scannedTools"
        (toolSelect)="onToolScanned($event)"
        (rowAlertClick)="onRowAlertClick($event)">
    </app-tool-inspect-tree>
</form>
